import { useQuery } from '@tanstack/react-query'
import { CostItem } from '../../../entities/Budget'
import { fetchCostItems } from '../../../api/core/costItems.ts'

export const useCostItems = () =>
  useQuery<CostItem[]>({
    queryKey: ['costItems'],
    queryFn: fetchCostItems,
    staleTime: 5 * 60 * 1000
  })
